import './index.css'
import './app'
import { initTheme } from './utils/theme.js'
import { initI18n } from './utils/i18n.js'

initTheme()
initI18n()
